import * as rive from '@rive-app/canvas'
import {
  ELITE_RENEW_CTA_RENEW,
  ELITE_RENEW_TEXT_RUN,
  EliteWrappedResponse,
  getEliteRenewCtaText
} from '../types/eliteWrapped.types'

const ELITE_RENEW_LINE1_RUN_CANDIDATES = [
  'Renew your PowerUp Elite',
  '-Renew your PowerUp Elite',
  'Continue to PowerUp Elite'
] as const

const ELITE_RENEW_LINE2_RUN = 'membership instantly' as const

function trySetTextRun(riveInstance: rive.Rive, name: string, value: string): boolean {
  try {
    riveInstance.setTextRunValue(name, value)
    return riveInstance.getTextRunValue(name) === value
  } catch {
    return false
  }
}

function parseRenewCtaLines(ctaText: string): { line1: string; line2: string } {
  if (ctaText.includes('\n')) {
    const [line1 = '', line2 = ''] = ctaText.split('\n')
    return { line1, line2 }
  }

  if (ctaText === ELITE_RENEW_CTA_RENEW) {
    return { line1: 'Renew your PowerUp Elite', line2: 'membership instantly' }
  }

  return { line1: ctaText, line2: '' }
}

/**
 * Applies renew CTA copy from `eliteRenewalStatus`. Text runs are not named `Elite_Renew`
 * (that is the tap event); copy is set on the line1/line2 run names in the .riv.
 */
export function applyEliteRenewTextRun(
  riveInstance: rive.Rive,
  eliteRenewalStatus: EliteWrappedResponse['eliteRenewalStatus'] | undefined
): string | null {
  const ctaText = getEliteRenewCtaText(eliteRenewalStatus)
  const { line1, line2 } = parseRenewCtaLines(ctaText)

  if (trySetTextRun(riveInstance, ELITE_RENEW_TEXT_RUN, ctaText)) {
    return ELITE_RENEW_TEXT_RUN
  }

  let appliedLine1 = false
  for (const runName of ELITE_RENEW_LINE1_RUN_CANDIDATES) {
    if (line1 && trySetTextRun(riveInstance, runName, line1)) {
      appliedLine1 = true
      break
    }
  }

  if (line2) {
    if (trySetTextRun(riveInstance, ELITE_RENEW_LINE2_RUN, line2)) {
      return appliedLine1 ? ELITE_RENEW_LINE2_RUN : null
    }
    return null
  }

  if (appliedLine1) {
    trySetTextRun(riveInstance, ELITE_RENEW_LINE2_RUN, '')
    return ELITE_RENEW_LINE1_RUN_CANDIDATES[0]
  }

  console.warn('[elite-recap] Could not apply renew CTA text.', { eliteRenewalStatus, ctaText })
  return null
}
